<template>
  <div class="whl-head-container">
    <div class="whl-mask" v-if="tabGuideShow && subjectArr.length > 1" @click="hideTabGuide">
      <div class="class_head">
        <div class="content_left"></div>
        <p class="whl-subject-tab" v-if="subjectArr.length > 1" ref="guideP">
          <span :class="subjectInTab === item.subject && selectState(item.subject)" v-for="item in subjectArr" :key="item.subject">{{item.subjectName}}</span>
          <img src="../../../../static/img/class/tab-guide.png" alt="guide" :style="{left: getGuideLeft}" ref="guideRef">
        </p>
        <div class="content_right cursor" :class="{'content_right_electron':LIMI_ENV}"></div>
      </div>
    </div>
    <div class="class_head">
      <div class="content_left">
        <div class="content_cos">
          <div class="whl-user">
            <div>
              <img :src="user_photo"  @click="goInfo" class="cursor" alt ondragstart="return false;">
              <img :src="userHeadwear" alt="" v-if="userHeadwear">
            </div>
            <div>
              <div>
                <p>{{realname | realSubstring}}</p>
                <p v-if="internal_users">
                  <i></i>
                  <span>内部员工</span>
                </p>
              </div>
              <p :class="changeTimeColor()">
                <template v-if="subjectArr.length > 0">{{subjectArr[subjectIndex].expireTitle}}{{subjectArr[subjectIndex].expireTime}}</template>
              </p>
            </div>
          </div>
        </div>
      </div>
      <p class="whl-subject-tab" v-if="subjectArr.length > 1">
        <span :class="subjectInTab === item.subject && selectState(item.subject)" @click="subjectClick(item.subject)" v-for="item in subjectArr" :key="item.subject">{{item.subjectName}}</span>
      </p>
      <div class="content_right cursor" :class="{'content_right_electron':LIMI_ENV}">
        <div
          v-show="entrance_status"
          :class="['game',updateMark?'updateMark':'']"
          @click="goGameMenu"
        >
          <img src="../../../assets/img/class/gameIcon.png" alt="小游戏入口">
          <span>学具乐园</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapMutations, mapState} from "vuex";
import common from "common";
import lottie from "lottie-web-limi";
export default {
  name: "class_head",
  data() {
    return {
      LIMI_ENV: LIMI_ENV === "electron",
      animationSpeed: 1,
      anim: '',
      result:0,
      // subject: 1,
      subjectIndex: 0
    };
  },
  computed: {
    ...mapState([
      "userID",
      "realname",
      "userBadgeNum",
      "user_photo",
      "entrance_status",
      "is_unread",
      "internal_users",
      "userHeadwear",
      "memberStatus",
      "expireTime",
      "replayExpireTime",
      "subjectInTab"
    ]),
    coinAllnum(){
      const coinAllnum = this.$store.state.coinAllnum;
      const lastCoinAllnum = common.get('lastCoinAllnum') || coinAllnum;
      common.set('lastCoinAllnum',coinAllnum);
      const result = coinAllnum - lastCoinAllnum;
      if(result>0){
        setTimeout(()=>{
          this.result = result;
          this.anim && this.anim.play()
        },500)
      }
      return coinAllnum
    },
    getGuideLeft() {
      this.$nextTick(()=> {
        this.$refs.guideRef.style.left = this.$refs.guideP.clientWidth / 2 + 'px';
      })
    }
  },
  props: {
    updateMark: {
      default: false,
      type: Boolean
    },
    subjectArr: {
      type: Array,
      default: () => []
    },
    tabGuideShow: {
      type: Boolean,
      default: () => false
    }
  },
  mounted() {
    this.playAmn()
  },
  watch: {
    subjectArr(n, o) {
      this.subjectIndex = this.subjectArr.findIndex(v => v.subject === this.subjectInTab);
    }
  },
  methods: {
    ...mapMutations(["saveSubjectInTab"]),
    changeTimeColor() {
      return this.subjectInTab == 1 ? 'whl-time-shuxue-color' : this.subjectInTab == 2 ? 'whl-time-yuwen-color' : this.subjectInTab == 3 ? 'whl-time-yingyu-color' : '';
    },
    //隐藏学科tab引导
    hideTabGuide() {
      this.$emit('hideTabGuide')
    },
    selectState(subject) {
      return subject === 1 ?  'whl-shuxue-select' : subject === 2 ? 'whl-yuwen-select' : subject === 3 ? 'whl-yingyu-select' : '';
    },
    subjectClick(subject) {
      // this.subject = subject;
      this.saveSubjectInTab(subject)
      console.log('subjectInTab',this.subjectInTab)
      this.subjectIndex = this.subjectArr.findIndex(v => v.subject === subject);
      this.$root.eventHub.$emit('changeClassList', subject);
    },
    goInfo(){
      this.$router.push('/userInfo');
    },
    toolShow(){
      this.$emit('toolShow',true)
    },
    //点击跳转到个人徽章页面
    openCoinWebView() {
      //this.$root.eventHub.$emit("goCoinWebView",true);
      this.$router.push({ name: "coinrecord" });
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventCoinClick",
        data: { page: 1 }
      });
    },
    //点击跳转到个人徽章页面
    goMyBadge() {
      this.$router.push({ name: "myselfBadge" });
    },
    goGameMenu() {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventGameClicked"
      });
      this.$router.push({ name: "gameMenu" });
    },
    goMessageList() {
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventMessageBtnClick",
        data: {}
      });

      this.$router.push("/msg");
    },
    playAmn() {
      this.anim = lottie.loadAnimation({
        container: document.querySelector(".lottie_class_coin"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: false,
        autoplay: false,
        path: '/static/lottie/coin1.json'
      });
    }
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.whl-head-container {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.whl-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 101;
  display: flex;
  align-items: center;
}
.whl-mask .class_head {
  position: absolute;
  left: 0;
  top: 0;
}
.whl-mask .whl-subject-tab {
  position: relative;
}
.whl-mask .whl-subject-tab>img:last-child {
  position: absolute;
  width: 340px;
  height: 147px;
  left: 60px;
  bottom: -150px;
}
.class_head {
  width: 100%;
  height: 140px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 24px;
  justify-content: space-between;
  color: #ffffff;
  position: relative;
  z-index: 100;
  padding: 10px 10px 0 38px;
  //overflow: hidden;
  box-sizing: border-box;
  .content_left {
    width: 320px;
    .content_cos{
      height:61px;
      //background:#0085aa;
      //background-color: rgba(255,255,255, .6);
      background-color: #B8E6FF;
      border-radius:60px;
      display: flex;
      align-items: center;
      max-width: 100%;
    }
    .whl-user {
      width: auto;
      height: 140px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #fff;
      margin-left: -37px;
      &>div:first-child {
        width: 140px;
        height: 140px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        &>img:first-child {
          width: 81px;
          height: 81px;
          border-radius: 50%;
          border: 2px solid #fff;
          position: relative;
          z-index: 2;
        }
        &>img:nth-child(2) {
          width: 140px;
          height: 140px;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 3;
          pointer-events: none;
        }
      }
      &>div:nth-child(2) {
        display: flex;
        flex-direction: column;
        margin-left: -10px;
      }
      &>div:nth-child(2)>div:first-child {
        display: flex;
        align-items: center;
        &>p:first-child {
          display: flex;
          color: rgba(43,43,43,0.85);
          font-size: 20px;
          margin-right: 10px;
          font-weight: 500;
        }
        &>p:nth-child(2) {
          height: 20px;
          font-size: 14px;
          color: #ffe286;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          &>i{
            display: block;
            width: 20px;
            height: 20px;
            background: url("../../../assets/img/class/own.png") no-repeat left center;
            background-size: 11px;
          }
        }
      }
      &>div:nth-child(2)>p:nth-child(2) {
        width: auto;
        height: 100%;
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
      }
      &>div:nth-child(2)>p:nth-child(2).whl-time-shuxue-color {
        color: #208AE0;
      }
      &>div:nth-child(2)>p:nth-child(2).whl-time-yuwen-color {
        color: #F79C00;
      }
      &>div:nth-child(2)>p:nth-child(2).whl-time-yingyu-color {
        color: #9C75FF;
      }
    }
    .coinbox {
      position: relative;
      .coin {
        pointer-events: none;
        position: relative;
        left:-25px;
        top: -1px;
        .lottie_class_coin{
          position: absolute;
          top: -48px;
          width: 110px;
          height: 103px;
        }
      .coinani {
        display: inline-block;
        vertical-align: middle;
        position: relative;
        top:-14px;
        z-index: 2;
        pointer-events: none;
      }
      .plusNum {
        position: absolute;
        opacity: 0;
        top:-10px;
        left:100px;
        z-index: 2;
        font-size: 16px;
        animation:plusani .6s ease-in;
        -webkit-animation:plusani .6s ease-in;
      }
    }
    }

    .coin,
    .badge {
      i {
        padding: 10px 25px;
        background: url(../../../assets/img/common/coin.png) no-repeat left
          center;
        background-size: 50px 50px;
        position: relative;
        z-index: 2;
      }
      span {
        padding: 0 22px 0 35px;
        position: relative;
        z-index: 1;
        margin-left: -25px;
        top:3px;
        border-radius: 0 22px 22px 0;
        font-family: Roboto_Regular;
      }
      .coinAllnum{
        margin-left: 55px;
        z-index: 1;
      }
    }
    .badge {
      margin-left: -20px;
      i {
        background: url(../../../assets/img/common/badge.png) no-repeat left
          center;
        background-size: 46px 46px;
      }
      span{
        padding: 6px 22px 6px 35px;
      }
    }
    .review {
      width: 78px;
      height: 59px;
      background: url(../../../assets/img/class/review_bg.png) no-repeat center
        center;
      background-size: 100% 100%;
      position: absolute;
      right: 20px;
      top: 44px;
      font-size: 20px;
      line-height: 80px;
      color: #ffffff;
    }
  }
  .whl-subject-tab {
    background: #fff;
    border-radius: 30px;
    width: auto;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    &>span {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
      padding: 0 50px;
      transition: all;
    }
    &>span.whl-shuxue-select {
      background-color: #208AE0;
      color: #fff;
      border-radius: 30px;
    }
    &>span.whl-yuwen-select {
      background-color: #E9870F;
      color: #fff;
      border-radius: 30px;
    }
    &>span.whl-yingyu-select {
      background-color: #8750C6;
      color: #fff;
      border-radius: 30px;
    }
  }
  .content_right_electron {
    margin-right: 80px;
  }
  .content_right {
    width: 150px;
    .game {
      position: relative;
      height: 50px;
      display: flex;
      align-items: center;
      margin-right: 20px;
      width: 100%;
      img {
        height: 50px;
        width: 50px;
        margin-right: 10px;
      }
      span {
        font-size: 18px;
      }
    }
    .filter{
      display: inline-block;
      width: 93px;
      height:50px;
      background: #0085aa;
      font-size: 16px;
      line-height: 50px;
      border-radius: 28px;
    }
    .updateMark::after {
      position: absolute;
      display: block;
      content: "";
      width: 10px;
      height: 10px;
      background: #f56c22;
      left: 40px;
      top: 1px;
      border-radius: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/class/class_head.vue